<template>
    <v-container fluid>
      <v-card class="pl-6 pr-6 pt-6 pb-6">
        <!-- <v-card class="ma-5" elevation="0"> -->
        <v-row>
          <v-col cols="12" md="6">
            <v-card-title class="text-h5">Work Type</v-card-title>
          </v-col>
          <v-col align="right"  cols="12" md="6" class="d-flex justify-end mb-6  mt-2"> 
            <v-btn
              v-if="authorize_add"
              to="/ip-price-add"
              rounded
              color="#0A7EA5"
              dark
              class="mb-2 ml-2"
            >
              <span>Add</span>
              <v-icon small center>add</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              class="widthsizesearch heightsizesearch"
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
  
        <br />
  
        <v-card outlined tile>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="mDataArray"
            class="elevation-1"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
            }"
          >

            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                :style="{
                  backgroundColor: '#E1F5FE',
                  color: '#254E58',
                }"
                @click="openeditItem(item.id)"
                v-if="authorize_edit"
                class="mr-2"
              >
                mdi-pencil
              </v-icon>

            </template>
          </v-data-table>
          <v-progress-linear
            indeterminate
            color="teal"
            v-if="load_bg"
          ></v-progress-linear>
        </v-card>
  
  
      </v-card>
      <!-- popup add -->
          <v-dialog v-model="dialogAddKeyword" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Add Keyword</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Object Type :</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-autocomplete
                        clearable
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Notice Type :</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-autocomplete
                        clearable
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="3" class="mt-2">
                      <h3>Keyword</h3>
                    </v-col>
                    <v-col cols="12" sm="12" md="9">
                      <v-text-field
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text>
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

      <!-- </v-card> -->
      <SuccessDialog
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
      />
      <SuccessDialogPush
        :status="dialogAdd"
        :text_color="text_color"
        :title="title"
        :message="message"
        :link="link"
      />
    </v-container>
  </template>
  
<script>
    import api from "@/services/api";
    import { server } from "@/services/constants";
    import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
    import SuccessDialog from "@/components/cards/SuccessDialog";
    import {
        tolocalestringnumber,
        stringcommatonumber,
    } from "./../computing/tolocalestringnumber";
    export default {
        name: "IPPriceList",
        async mounted() {
        this.$showLoader();
        await api.checkVersion();
    
        // ----------------- Check Authorize ---------------------------
        this.userId = localStorage.getItem(server.USER_ID);
        let yourUrlString = window.location;
        // alert(yourUrlString);
    
        let parser = document.createElement("a");
        parser.href = yourUrlString;
    
        this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
        // alert("authorize_id:" + this.authorize_id);
        if (this.authorize_id == null || this.authorize_id == 0) {
            // this.$router.push("/login");
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
            true,
            "Authorize Failed",
            "Please Logout And Login Again",
            "text-h5 red--text text-center"
            );
            this.$router.back();
        }
    
        const router_path = parser.pathname.replace("/", "");
    
        const res_auth = await api.getAuthorize(this.userId, router_path);
    
        console.log("res_auth:" + JSON.stringify(res_auth.data));
    
        this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
        this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
        this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
        this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;
    
        // console.log("res_auth:" + JSON.stringify(res_auth.data));
        // console.log("authorize_view:" + this.authorize_view);
        // console.log("authorize_add:" + this.authorize_add);
        // console.log("authorize_edit:" + this.authorize_edit);
        // console.log("authorize_del:" + this.authorize_del);
        // this.$router.back();
    
        if (!this.authorize_view) {
            this.$router.back();
        }
    
        // // ----------------- Check Authorize ---------------------------
        await this.loaddata();
        this.$hideLoader();
        },
        components: { SuccessDialog, SuccessDialogPush },
        data() {
        return {
            userId: 0,
            data_del_id: 0,
            authorize: [],
            authorize_view: false,
            authorize_add: false,
            authorize_edit: false,
            authorize_del: false,
            authorize_id: 0,
            load_bg: false,
            dialogAddKeyword: false,
            dialogAdd: false,
            dialogAddData: false,
            isShowPassword: false,
            fullPage: true,
            search: "",
            mDataArray: [],
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            search_ct: "",
        
            edititemdata: {
            contact_type: 0,
            contact_name: "",
            contact_person: "",
            position: "",
            email: "",
            address: "",
            city: "",
            country: "",
            telephone: "",
            fax: "",
            },
            contactid_del: 0,
            oparation: "",
            headers: [
            {
                text: "Object Type",
                value: "obj_code",
                class: "bg-colorth",
                divider: true,
                width: "120px",
            },
            {
                text: "Work Type",
                value: "documenttype_code",
                class: "bg-colorth",
                divider: true,
                width: "140px",
            },
            
            {
                text: "Sequence",
                value: "sequence",
                class: "bg-colorth",
                divider: true,
                width: "100px",
            },
            {
                text: "Status",
                value: "doc_status",
                class: "bg-colorth",
                divider: true,
                width: "100px",
            },
            
            {
                text: "",
                value: "actions",
                class: "bg-colorth",
                divider: true,
                align:"center",
                width: "50px",
            },
            ],
        };
        },
        methods: {
        async loaddata() {
            this.$showLoader();
            const result = await api.getdocumenttypeList();
            this.mDataArray =  result.data;
            console.log(this.mDataArray)
        },
        async openeditItem(id) {
            // alert(id)
            this.$router.push(`/ip-price-edit/${id}`);

        },



        setupAlertDialogPush(status, title, message, text_color, link) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
            this.link = link;
        },
        setupAlertDialog(status, title, message, text_color) {
            this.title = title;
            this.message = message;
            this.dialogAdd = status;
            this.text_color = text_color;
        },
        },
        beforeCreate() {
        this.$store.state.navMenu = true;
        },
    };
</script>
  
<style scoped>
    .widthbtnimagefile {
        width: 40%;
    }
    .widthsizesearch {
        width: 70%;
    }
    .v-btn:not(.v-btn--round).v-size--default.buttonblue {
        background-color: #1d2442;
        color: white;
    }
    .btnuploadfile {
        border: 2px solid;
    }
    .heightsize70formadvance {
        height: 80px;
    }
    
    .vali {
        color: red;
    }
    
    h3 {
        font-size: 1.17em;
    }
    
    .heightsizesearch {
        height: 45%;
    }
</style>
  